import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { records as userRecords } from '@saucelabs/sl-module-user';
import ImmutablePropTypes from 'react-immutable-proptypes';

const SelfServeOrgAdminContainer = (props) => {
  const {
    user,
    children,
  } = props;

  if (!user.isOrgAdmin() || !user.canSelfServe()) {
    return <Redirect to="/dashboard" />;
  }

  return children;
};

export const mapStateToProps = ({ user }) => ({
  user,
});

SelfServeOrgAdminContainer.propTypes = {
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass).isRequired,
};

export default withRouter(connect(mapStateToProps)(SelfServeOrgAdminContainer));

export {
  SelfServeOrgAdminContainer,
};
